// Small colored dot rendered next to a contact's name in list views
// and detail headers to show where they sit in the Zoe/Kaden outreach
// cadence (Phase B, Dave 2026-06-09):
//
//   yellow → 'initial'  → initial email sent, awaiting response
//   orange → 'followup' → follow-up sent
//   red    → 'breakup'  → "should I close the file?" sent
//   none   → no outreach in progress (no dot rendered)
//
// Tooltip on hover spells out what the color means so anyone hovering
// can figure out the system without having to ask.

const STAGE_META = {
  initial:  { color: '#facc15', label: 'Initial outreach sent (yellow)' },
  followup: { color: '#fb923c', label: 'Follow-up sent (orange)' },
  breakup:  { color: '#ef4444', label: 'Breakup email sent (red)' }
};

// Text-readable variants of the stage colors -- the dot palette is too
// light for body text on white. Use these for `style.color` on company
// names / chips so the row is scannable from across the page without
// fighting readability. Falls back to undefined when no stage is set,
// so callers can spread it into a style object without conditional
// branching.
//
//   initial  -> amber-700 (#a16207) -- deep yellow, readable
//   followup -> orange-700 (#c2410c)
//   breakup  -> red-700 (#b91c1c)
const TEXT_COLOR = {
  initial:  '#a16207',
  followup: '#c2410c',
  breakup:  '#b91c1c'
};

export function stageTextColor(stage) {
  return TEXT_COLOR[stage];
}

export default function OutreachStageDot({ stage, size = 10, style }) {
  const meta = STAGE_META[stage];
  if (!meta) return null;
  return (
    <span
      title={meta.label}
      aria-label={meta.label}
      style={{
        display:       'inline-block',
        width:         size,
        height:        size,
        borderRadius:  '50%',
        backgroundColor: meta.color,
        // Subtle border tightens it against light backgrounds without
        // becoming a noisy outline.
        boxShadow:     '0 0 0 1px rgba(0,0,0,0.05)',
        verticalAlign: 'middle',
        marginRight:   6,
        flexShrink:    0,
        ...style
      }}
    />
  );
}
